<template>
  <div class="empty-box">
    <div class="wrap">
      <div class="img"></div>
      <div class="txt">暂无信息</div>
      <div v-if="redirectUrl" class="btn" @click="reload()">
        <img src="@/assets/images/refresh.png" />
        刷新页面
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { projectStorage, setQuery } from '@tencent/fd-utils';
import { getRedirectUrlByAppKey } from '@/config/httpConfig';

const redirectUrl = getRedirectUrlByAppKey();
const reload = () => {
  // 在微信和企微端刷新时，地址如果完全不变，其存在缓存，所以加一个随机数避免无法刷新
  window.location.href = setQuery(`t=${Math.random()}`, redirectUrl);
};
</script>
<style lang="less" scoped>
.empty-box {
  display: flex;
  position: fixed;
  top: 0;
  z-index: 9998;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: #fff;

  .wrap {
    margin: auto;
    width: 320px;
    background-repeat: no-repeat;
    background-size: cover;

    .img {
      height: 320px;
      background-image: url('@/assets/images/emptybox.png');
    }

    .txt {
      margin-top: 40px;
      text-align: center;
      font-weight: 400;
      font-size: 28px;
      color: #667082;
    }

    .btn {
      margin: auto;
      margin-top: 32px;
      border-radius: 6px;
      width: 224px;
      height: 64px;
      background-color: #07f;
      cursor: pointer;
      line-height: 68px;
      text-align: center;
      font-size: 28px;
      color: #fff;

      img {
        margin-right: 8px;
        width: 32px;
        height: 32px;
        vertical-align: text-top;
      }
    }
  }
}
</style>
